import {http} from './config/config-receituario'

export default{
    listar:(token, page = 1, limit = 20)=>{
        return  http.get('produtores',{
            params: {
                page,
                limit,
            },
            headers:{
                'Authorization':token
            }
        })
    },
    listarByFilter:(token, nome, page = 1, limit = 20)=>{
        return  http.get(`produtores/filter?nome=${encodeURIComponent(nome)}`,{
            params: {
                page,
                limit,
            },
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, produtor)=>{
        return http.post('produtores',produtor,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idProdutor)=>{
        return http.delete('produtores/'+idProdutor,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, produtor)=>{
        return http.put('produtores/'+produtor.id_produtor_rural,produtor,{
            headers:{
                'Authorization':token
            }
        })
    },
    syncTorge:(token, idProdutor)=>{
        return http.post(`integrations/torge/clientes/produtor/${idProdutor}/sync`, null, {
            headers:{
                'Authorization':token
            }
        })
    }

}
